import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5b1dbf6a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./style.styl?vue&type=style&index=0&id=5b1dbf6a&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1dbf6a",
  null
  
)

export default component.exports